import { ReactNode } from "react";
import { Box, Stack } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {
  formFieldsWrapperSx,
  sectionHeaderSx,
  sectionPanelSx,
} from "../produto-form.theme";

interface Props {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  noPadding?: boolean;
}

export default function ProdutoFormSection({
  title,
  subtitle,
  icon,
  action,
  children,
  noPadding,
}: Props): JSX.Element {
  return (
    <MDBox sx={sectionPanelSx}>
      <MDBox sx={sectionHeaderSx}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={2}
        >
          <Stack direction="row" spacing={1.5} alignItems="center" minWidth={0}>
            {icon ? (
              <Box sx={{ display: "flex", color: "#F96030", flexShrink: 0 }}>{icon}</Box>
            ) : null}
            <Box minWidth={0}>
              <MDTypography variant="h6" fontWeight="bold">
                {title}
              </MDTypography>
              {subtitle ? (
                <MDTypography variant="caption" color="text.secondary" display="block">
                  {subtitle}
                </MDTypography>
              ) : null}
            </Box>
          </Stack>
          {action}
        </Stack>
      </MDBox>
      <MDBox sx={noPadding ? formFieldsWrapperSx : { p: 3, ...formFieldsWrapperSx }}>
        {children}
      </MDBox>
    </MDBox>
  );
}
